<template>
  <section>
    <router-view />
  </section>
</template>

<script>
import DocumentUIService from '/@/modules/core/app/services/DocumentUIService';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'CeWebsiteEmbedLayout',
  async beforeRouteEnter(to, from, next) {
    DocumentUIService.removeAppLoader();
    next();
  }
};
</script>
